import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { Button, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { PopupConfirm, styleVariables } from '@lib/common';
import { Size, FileType } from '../../../../file-storage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Content = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  border-radius: 4px;\n  background: ", ";\n\n  width: 100%;\n  padding: 8px 16px 8px 8px;\n\n  transition: transform 0.5s;\n  &:hover {\n    transform: scale(1.01);\n    cursor: pointer;\n  }\n"])), styleVariables.colors.gray3);
var ImagePreview = styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 40px;\n  height: 24px;\n\n  border: 1px solid lightgray;\n"])));
var FileSize = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n"])));
var VerticalLine = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 10px;\n\n  background: ", ";\n"])), styleVariables.colors.gray9);
var CloseButton = styled(Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 30px;\n\n  border-radius: 50%;\n\n  &:hover {\n    background: lightgray;\n  }\n"])));
export var SubmissionAnswerUploadedFilePreview = function SubmissionAnswerUploadedFilePreview(props) {
  var signedUrl = props.signedUrl,
      type = props.type,
      size = props.size,
      onClick = props.onClick,
      fileStorageId = props.fileStorageId,
      onDelete = props.onDelete,
      label = props.label;

  var handleDelete = function handleDelete(e) {
    e.stopPropagation();
    onDelete(fileStorageId);
  };

  var renderPreviewFileByType = function renderPreviewFileByType() {
    switch (type) {
      case FileType.Image:
        {
          return /*#__PURE__*/_jsx(ImagePreview, {
            src: signedUrl
          });
        }
    }
  };

  return /*#__PURE__*/_jsxs(Content, {
    onClick: onClick,
    children: [renderPreviewFileByType(), /*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      size: "middle",
      children: [/*#__PURE__*/_jsx(FileSize, {
        children: Size.format(size)
      }), /*#__PURE__*/_jsx(VerticalLine, {}), /*#__PURE__*/_jsx(PopupConfirm, {
        title: label.deleteTitle,
        okText: label.deleteOk,
        cancelText: label.deleteCancel,
        onConfirm: handleDelete,
        onCancel: function onCancel(e) {
          return e.stopPropagation();
        },
        children: /*#__PURE__*/_jsx(CloseButton, {
          type: "text",
          icon: /*#__PURE__*/_jsx(CloseOutlined, {}),
          onClick: function onClick(e) {
            return e.stopPropagation();
          }
        })
      })]
    })]
  });
};